import { Box, Heading, Text, VStack } from '@chakra-ui/react';

export const Forbidden = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh" bg="gray.100">
      <VStack spacing={6} textAlign="center" bg="white" p={8} borderRadius="lg" boxShadow="lg">
        <Heading fontSize="6xl" color="red.500">
          403
        </Heading>
        <Text fontSize="xl" color="gray.600">
          Oops! You are not Authorised to access the page.
        </Text>
      </VStack>
    </Box>
  );
};
